import { post } from "../../api";
import { authHeader } from "../../utils";

const loadPhonepe = body => post("loadPhonepe", authHeader(), body);
const phonepeValidateVpa = body => post("phonepeValidateVpa", authHeader(), body);
const onPaymentValidate = body => post("postPayment", authHeader(), body);

export { loadPhonepe, phonepeValidateVpa, onPaymentValidate };